import { AxiosError, AxiosResponse } from "axios";
import { createApi } from "./createApi";
import { useSyncStore } from "./syncStore";
import { NavigateFunction } from "react-router-dom";
import { lchown } from "fs";
import { saveUserTimezone } from "./saveUserTimezone";
import { useAppStore } from "../../appStore";
import { safeSetItem } from "./localStorageUtils";
import { logger } from "../../utils/logger";
import { getRefreshTimeout } from "./getRefreshTimeout";
import { useClipsStore } from "../pages/Clips/ClipsStore/clipsStore";

const apiResources = [
  [`user/info/`, "userInfo"],
  [`timezone/`, "timeZoneArray"],
  [`option/product/`, "products"],
  [`integration_type/onboarding/`, "integrationTypes"],
  [`integration_type/`, "integrationTypesNonOnboarding"],
  [`group/?page_size=2027`, "groupArray"],
  [`schedule_location/`, "locations"],
  [`group/?page_size=10000`, "parentGroups"],
  // [`analytics/data_usage/?date_range=last_24_hours`, "top5DataUsage"],
  [`analytics/date_range_choices/`, "rangeChoices"],
  [`group/?parent_account=true&page_size=10000`, "parentAccounts"],
  [`customer/default_alarm_option/`, "alarmOptions"],
  [`immix_credential/?user_type=ailink`, "aiLinkUsers"],
  [`immix_credential/?user_type=sentinel`, "sentinelUsers"],
  [`product_requirements`, "productRequirements"],
  [`option/?parent__value=camera_view`, "cameraViewOptions"],
  [`webhook/event_types/`, "webHookEventTypeOptions"],
  [`calendar/`, "calendarsData"],
  [`storage/user/`, "userStorage"],
  [`group/tree/?group_type=patrol`, "groupTreesPatrolOnly"],
];

async function getResource(
  resource: string[],
  setPermissions?: any,
  setUserPermissions?: any
) {
  const AxiosUI = createApi(``);
  localStorage.setItem("navBarCollapsed", "true");
  localStorage.setItem("siteSchedule", "false");
  localStorage.setItem("selectedProducts", "false");
  localStorage.setItem("siteInfo", "false");
  localStorage.setItem("ignoreZones", "false");
  localStorage.setItem("cameraNumber", "1");
  localStorage.setItem("currentCamera", "");
  localStorage.setItem("preview_url", "false");
  localStorage.setItem("clickedFromSiteAboutPage", "false");
  localStorage.setItem("siteDeletedAlert", "false");
  useSyncStore.getState().clearAllUnsynced();
  localStorage.setItem("sitesTablePage", "0");
  localStorage.setItem("sitesRowsPerPage", "10");
  localStorage.setItem("siteGroupListScrollTop", "0");
  localStorage.setItem("level0Click", "true");
  localStorage.setItem("siteAboutScrollTop", "0");
  localStorage.setItem("groupNameChange", "true");
  localStorage.setItem("dashboardTotal", "false");
  localStorage.setItem("falsePostiveData", "false");
  localStorage.setItem("camerasErrorInfo", "false");
  localStorage.setItem("camerasWarningInfo", "false");
  localStorage.setItem("rebootSite", "false");
  localStorage.setItem("immixAlertsSite", "false");
  localStorage.setItem("sentinelAlertsSite", "false");
  localStorage.setItem("sureviewAlertsSite", "false");
  localStorage.setItem("diceAlertsSite", "false");
  localStorage.setItem("SMTPSite", "false");
  localStorage.setItem("noAutoAddCamerasDialogOpen", "false");
  localStorage.setItem("currentSiteBreadcrumbs", JSON.stringify([]));
  localStorage.setItem("top5DataUsage", JSON.stringify([]));
  localStorage.setItem("percetageOfMotionData", JSON.stringify([]));
  localStorage.setItem("navigatedToAnalyticsFromSitesPage", "false");
  localStorage.setItem("filtersSavedClicked", "false");
  localStorage.setItem("groupID", "1");
  localStorage.setItem("refresh_interval", JSON.stringify(30000));
  localStorage.setItem("alertsIconOpen", "");
  localStorage.setItem("patrolsIconOpen", "");
  localStorage.setItem("newCalendarName", "");
  localStorage.setItem("tokenRefreshing", "false");
  safeSetItem("alertsAllData", [], {
    maxRetries: 0,
    clearOnQuotaExceeded: false,
  });
  safeSetItem("alertsErrorsData", [], {
    maxRetries: 0,
    clearOnQuotaExceeded: false,
  });
  safeSetItem("alertsWarningsData", [], {
    maxRetries: 0,
    clearOnQuotaExceeded: false,
  });
  safeSetItem("alertsResolvedData", [], {
    maxRetries: 0,
    clearOnQuotaExceeded: false,
  });
  safeSetItem("alertsPendingData", [], {
    maxRetries: 0,
    clearOnQuotaExceeded: false,
  });
  localStorage.setItem("editCamerActiveTab", "one");
  safeSetItem("sortedHMAlertsRows", [], {
    maxRetries: 0,
    clearOnQuotaExceeded: false,
  });
  localStorage.setItem("healthcheckOnly", "false");
  localStorage.setItem("queryString", JSON.stringify(``));
  localStorage.setItem("moreThan100InvestigationsData", "false");
  localStorage.setItem("last_timestamp", "false");
  localStorage.setItem("showWebHooksOnboardingScreen", JSON.stringify(false));
  localStorage.setItem("last_file_id_sentinal", "");
  localStorage.setItem("last_timestamp_sentinal", "");
  localStorage.setItem("last_file_id_ailink", "");
  localStorage.setItem("last_timestamp_ailink", "");
  localStorage.setItem("armButtonCheckURL", "");
  localStorage.setItem("siteCamerasTablePagePreferences", JSON.stringify({}));
  localStorage.setItem("cameraCheckAlertOpen", "false");
  safeSetItem("selectedCHMAlertsArray", [], {
    maxRetries: 0,
    clearOnQuotaExceeded: false,
  });
  localStorage.setItem("selectedRowAlerts", "{}");
  localStorage.setItem("selectedGroupOrSiteId", "0");
  safeSetItem(
    "selectedItemSiteGroupList",
    {},
    { maxRetries: 0, clearOnQuotaExceeded: false }
  );
  safeSetItem(
    "backupHealthCheckMetricsData",
    {},
    { maxRetries: 0, clearOnQuotaExceeded: false }
  );
  localStorage.setItem("schedulesIndex", "0");
  safeSetItem("backUpFlexSchedule", [], {
    maxRetries: 0,
    clearOnQuotaExceeded: false,
  });
  localStorage.setItem("flexSchedulingChanged", "false");
  localStorage.setItem("selectedImmixAlertId", "");
  localStorage.setItem("getIndividualGroupId", "");
  localStorage.setItem("searchCameraInputValue", "");
  localStorage.setItem("healthMonitoringOnly", "false");
  localStorage.setItem("alertsFailRetryCount", "0");
  // safeSetItem("parentAccounts", [], {
  //   maxRetries: 0,
  //   clearOnQuotaExceeded: false,
  // });
  safeSetItem(
    "addCameraInfo",
    {},
    { maxRetries: 0, clearOnQuotaExceeded: false }
  );
  localStorage.setItem(
    "visibleSchedules",
    JSON.stringify({
      one: true,
      two: false,
      three: false,
    })
  );
  localStorage.setItem("clickedSchedulesTab", "one");
  localStorage.setItem("flexSchedulesOn", "false");
  localStorage.setItem(
    "immixAlertPostObject",
    JSON.stringify({
      id: -1,
      immix_server: "",
      immix_port: "",
    })
  );
  localStorage.setItem(
    "sentinelAlertPostObject",
    JSON.stringify({
      sentinel_server: "",
      sentinel_site_id: "",
      sentinel_device_address: "",
      draw_ignore_zones: false,
    })
  );
  localStorage.setItem(
    "patriotAlertPostObject",
    JSON.stringify({
      patriot_server: "",
      patriot_client_no: "",
      patriot_username: "",
      patriot_password: "",
      patriot_zone_number: "",
      patriot_type_number: "",
      patriot_send_video: false,
      draw_ignore_zones: false,
    })
  );
  localStorage.setItem(
    "storedSelectedIndex",
    JSON.stringify({
      level1: "",
      level2: "",
      level3: "",
      level4: "",
      level5: "",
      level6: "",
    })
  );
  saveUserTimezone();
  const { data } = await AxiosUI.get(resource[0]);
  if (resource[1] === "parentAccounts") {
    localStorage.setItem("groupID", data.results[0].id);
    getRefreshTimeout(data.results[0].id);
  }
  if (resource[1] === "userInfo") {
    localStorage.setItem("username", data.username);
    localStorage.setItem("first_name", data.first_name);
    localStorage.setItem("last_name", data.last_name);
    localStorage.setItem("userInfo", JSON.stringify(data));
    const responsePermissions = data.permission;

    if (data.permission.patrol_only) {
      localStorage.setItem("patrolOnly", "true");
    }

    // Create a new permissions object to update both state values
    const newPermissions: any = {};
    // run a for loop on the responsePermissions and set every key to the value of the key

    for (const key in responsePermissions) {
      setPermissions((prev: any) => {
        return {
          ...prev,
          [key]: responsePermissions[key],
        };
      });
      // Add to the new permissions object
      newPermissions[key] = responsePermissions[key];
    }
    // Update the global permissions state with the complete object
    setUserPermissions(newPermissions);
    localStorage.setItem("userPermissions", JSON.stringify(newPermissions));
  } else if (resource[1] === "timeZoneArray") {
    const tzArray: string[] = [];
    data.forEach((item: { value: string }) => {
      tzArray.push(item.value);
    });
    localStorage.setItem(`${resource[1]}`, JSON.stringify(tzArray));
  } else if (
    resource[1] === "products" ||
    resource[1] === "integrationTypes" ||
    resource[1] === "integrationTypesNonOnboarding" ||
    resource[1] === "locations" ||
    resource[1] === "rangeChoices" ||
    resource[1] === "alertsByParentGroups" ||
    resource[1] === "alarmOptions" ||
    resource[1] === "aiLinkUsers" ||
    resource[1] === "sentinelUsers" ||
    resource[1] === "productRequirements" ||
    resource[1] === "cameraViewOptions" ||
    resource[1] === "webHookEventTypeOptions" ||
    resource[1] === "calendarsData" ||
    resource[1] === "userStorage"
  ) {
    localStorage.setItem(`${resource[1]}`, JSON.stringify(data));
    if (resource[1] === "aiLinkUsers") {
      localStorage.setItem(`aiLinkUserName`, data[0]?.username);
    }
    if (resource[1] === "sentinelUsers") {
      localStorage.setItem(`sentinelUserName`, data[0]?.username);
    }
    if (resource[1] === "userStorage") {
      const setDateMMDDYYYY = useAppStore.getState().setDateMMDDYYYY;
      if (data?.data?.alert_date_format) {
        if (data.data.alert_date_format === "DD/MM/YYYY") {
          setDateMMDDYYYY(false);
        }
        if (data.data.alert_date_format === "MM/DD/YYYY") {
          setDateMMDDYYYY(true);
        }
      } else {
        setDateMMDDYYYY(true);
      }
    }
  } else if (resource[1] === "top5DataUsage") {
    const updatedData = data;
    for (const key in updatedData) {
      const updatedKey: any = updatedData[key];
      updatedKey.abreviated_name = `${updatedKey.display_name.slice(0, 7)}...`;
      if (updatedKey.kbs) {
        const updatedKBS = Math.round(updatedKey.kbs / 10) / 100;
        updatedKey.kbs = updatedKBS;
      }
    }
    safeSetItem(`${resource[1]}`, updatedData, {
      maxRetries: 1,
      clearOnQuotaExceeded: true,
    });
  } else if (resource[1] === "groupTreesPatrolOnly") {
    useAppStore.getState().setGroupTreesPatrolOnly(data.results);
  } else {
    safeSetItem(`${resource[1]}`, data.results, {
      maxRetries: 1,
      clearOnQuotaExceeded: true,
    });
  }
}

async function getGroupTrees() {
  const AxiosUI = createApi(``);
  try {
    const { data } = await AxiosUI.get(
      `group/tree/?group_type=connector&page_size=1000`
    );
    useAppStore.getState().setGroupTrees(data.results);
    return data.results;
  } catch (error) {
    logger.error("Error fetching group trees:", error);
    throw error;
  }
}

export async function getAllResources(
  setPermissions: any,
  setUserPermissions: any,
  navigate?: NavigateFunction
) {
  const apiPromises = apiResources.map((resource) =>
    getResource(resource, setPermissions, setUserPermissions)
  );
  const groupTreesPromise = getGroupTrees();

  try {
    const results = await Promise.all([...apiPromises, groupTreesPromise]);
    const groupTreesData = results[results.length - 1]; // Last result is from groupTreesPromise

    // Fetch Frontel user groups after all resources are loaded (await so showFrontelTab
    // is set before login completes and user can land on Clips with tab=frontel)
    if (navigate) {
      const { getUserGroupsFrontel } = useClipsStore.getState();
      await getUserGroupsFrontel(navigate);
    }

    // Dispatch custom event to notify that user resources have been loaded
    window.dispatchEvent(new CustomEvent("userResourcesLoaded"));

    return groupTreesData;
  } catch (response: any) {
    if (response.response) {
      if (response.response.data) {
        if (response.response.data.detail === "Pending MFA Setup") {
          localStorage.setItem("getMFA", "true");
        }
      }
    }
    throw response;
  }
}
